import { useState, useEffect } from "react";

export function useDebounce<T>(state: T, delayInMs: number): T {
  const [debouncedState, setDebouncedState] = useState(state);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedState(state), delayInMs);

    return () => clearTimeout(handler);
  }, [state, delayInMs]);

  return debouncedState;
}
